import * as React from "react";
import { DataGrid, GridColDef, GridToolbar } from "@mui/x-data-grid";
import { Dialog } from "@mui/material";
import { PrinterDialog } from "./printer-dialog";

const columns: GridColDef[] = [
  { field: "id", headerName: "ID", width: 90 },
  {
    field: "reference",
    headerName: "Código Interno",
    width: 80,
  },
  {
    field: "description",
    headerName: "Descrição",
    width: 500,
  },
  {
    field: "ean",
    headerName: "EAN",
    width: 130,
  },
];

export type ProductTableRow = {
  id: string;
  reference: string;
  description: string;
  ean: string;
};

type Props = {
  data: ProductTableRow[];
};

export default function ProductTable({ data }: Props) {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const [code, setCode] = React.useState<string>("");
  return (
    <div style={{ width: "100%" }}>
      <PrinterDialog open={dialogOpen} setIsOpen={setDialogOpen} code={code} />
      <DataGrid
        rows={data}
        columns={columns}
        slots={{
          toolbar: GridToolbar,
        }}
        onRowDoubleClick={(row) => {
          if (!row.row.ean) {
            return alert("Produto sem EAN cadastrado");
          }
          setCode(row.row.ean);
          setDialogOpen(true);
        }}
        initialState={{
          columns: {
            columnVisibilityModel: {
              id: false,
            },
          },
        }}
      />
    </div>
  );
}
